export default __webpack_public_path__ + "static/media/logo.c2d3e342.svg";